<div class="absolute bg border-round-right">
  <div class="flex flex-row align-items-center gap-1 pl-4 p-3">
    <i [ngClass]="icon" class="pr-2"></i>
    <span class="font-bold text-2xl text-left">{{ title }}</span>
    <span class="font-light text-2xl text-left">{{ subtitle }}</span>
  </div>
</div>
